import { RoutePath } from 'src/router';

import { LinkWithParams } from '@itm/shared-frontend/lib/components';

import { clientPortalDashboardUrl } from 'src/utils/constants';

export default function PermissionDenied() {
  return (
    <div className="pt-6">
      <div className="container px-2">
        <div className="content card px-5 py-5">
          <h2 className="is-size-2">Permission Denied</h2>
          <p>
            You may visit <LinkWithParams to={RoutePath.root}>the Main Page</LinkWithParams>
          </p>
          <p>
            Or visit Client Portal Dashboard{' '}
            <LinkWithParams to={clientPortalDashboardUrl} isExternal>
              {clientPortalDashboardUrl}
            </LinkWithParams>{' '}
            to see all available modules
          </p>
        </div>
      </div>
    </div>
  );
}
